module.exports = __webpack_public_path__ + "static/media/wind.d4da2c58.png";